import { all } from 'redux-saga/effects';
import { watchPageSettingInfo } from './systems';
import { watchAuthen } from './authen';
import { watchRegister } from './register';
import { watchProfile } from './profile';
import { watchProducts } from './products';
import { watchAttribute } from './attribute';
import { watchAuthCms } from './cms/authen_cms';
import { watchMasterCategory } from './master-category';
import { watchMasterBrand } from './master-brand';
import { watchMasterProduct } from './master-product';
import { watchInternalCategory } from './internal-category';
import { watchBranch } from './branch';
import { watchHomeManagement } from './home-management';
import { watchTemplateManagement } from './template-management';
import { watchMember } from './member';
import { watchOrder } from './order';
import { watchRolePermission } from './role-permission';
import { watchReport } from './report';
import { watchCoupon } from './coupons';
import { watchBigPiont } from './big-point';

export default function* rootSaga() {
  try {
    yield all(
      [
        watchPageSettingInfo(),
        watchAuthen(),
        watchRegister(),
        watchProfile(),
        watchProducts(),
        watchAttribute(),
        watchAuthCms(),
        watchMasterCategory(),
        watchMasterBrand(),
        watchMasterProduct(),
        watchInternalCategory(),
        watchBranch(),
        watchHomeManagement(),
        watchTemplateManagement(),
        watchMember(),
        watchOrder(),
        watchRolePermission(),
        watchReport(),
        watchCoupon(),
        watchBigPiont(),
      ]);
  }
  catch (err) {
    console.error(err);
  }
}
